module.exports = __webpack_public_path__ + "04_medium_gold.bcd76c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_medium_gold.png
// module id = Vaxy
// module chunks = 0